import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import master from './modules/master'
import tenants from './modules/tenants'
import leads from './modules/leads'

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    master, 
    tenants,
    leads
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js